import React from 'react'
import "./Home.css";
//import Header from '../components/Header/Header'
import PaginaInicio from '../components/PaginaInicio/PaginaInicio';

const Home = () => {
 
  
  return (
    
    <div className="home-container">
        <PaginaInicio/>
      
    </div>
    
    
  );
};

export default Home;
